<template>
    <div class="">
        <banner :type="3"></banner>
        <div class="w-1200 productCate bgc-gray">
            <div class="flex flex-wrap">
                <div class="item" v-for="item in productCate" :key="item.id"
                     :class="{'active':id == item.id}" @click="getProductList(item)">
                    {{item.name}}
                </div>
            </div>
            <div class="position-r">
                <input type="text" v-model="text" placeholder="请输入关键字或产品货号"/>
                <img width="30" @click="search" src="../assets/img/sousuo.svg" alt=""
                     style="position:absolute;left: 550px;top: 18px;">
            </div>
        </div>
        <product-list :header-style="true" :productName="productName" :product-list="productList"/>
    </div>
</template>

<script>
    import ProductList from "../components/productList";

    export default {
        name: 'productCenter',
        components: {ProductList},
        props: {},
        data() {
            let that = this
            return {
                banner: [],
                productCate: [],
                productList: [],
                id: that.$route.query.id,
                text: '',
                productName: that.$route.query.name
            }
        },
        async mounted() {
            await this.getProductCate()
            console.log(1, this.$route.query)
            if (this.$route.query.id) {
                this.getProductList()
            } else if (this.productCate[0]) {
                this.getProductList(this.productCate[0])
            }
        },
        methods: {
            // 获取产品分类
            async getProductCate() {
                this.productCate = await this.$api.getProductCate()
            },
            // 获取产品列表
            async getProductList(item) {
                if (item) {
                    this.id = item.id
                    this.productName = item.name
                }
                this.productList = await this.$api.getProductList({cate_id: this.id})
            },
            async search() {
                if (!this.text) return
                this.productList = await this.$api.getProductList({cate_id: this.id, keywords: this.text})
            }
        },

    }
</script>
<style scoped lang="scss">
    .active {
        color: $red;
        position: relative;
        font-weight: 600;
    }

    .active::after {
        position: absolute;
        content: '';
        left: 0;
        bottom: 24px;
        width: calc(100% - 55px);
        height: 4px;
        border-radius: 2px;
        background-color: $red;
    }

    .productCate {
        padding: 50px 0 40px;

        .item {
            height: 66px;
            padding-right: 55px;
        }

        input {
            width: 550px;
            height: 64px;
            background: #FFFFFF;
            border-radius: 32px;
            padding: 0 30px;
            border: 0;
        }
    }
</style>
